import React from 'react';
const link =
  'https://gargleblaster.github.io/tudocs/TradePlans/ExitTactics/exit-tactics#candle-magnitude';

const CandleMagnitudeDocumentation = (
  <p>
    Please refer to the docs found here: <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
  </p>
);

export default CandleMagnitudeDocumentation;
